/* globals ErrorHandler */

import Dropzone from 'dropzone'

window['uploads#index'] = function () {
  document.querySelectorAll('.copy2clipboard').forEach((el) => {
    el.addEventListener('click', function (event) {
      event.preventDefault()
      const temp = document.createElement('input')
      document.body.appendChild(temp)
      temp.value = this.dataset.link
      temp.select()
      document.execCommand('copy')
      temp.remove()
    })
  })

  const dropzoneForm = document.querySelector('form.dropzone-uploads')
  if (dropzoneForm && dropzoneForm.dropzone) { dropzoneForm.dropzone.destroy() }
  if (!dropzoneForm) return

  // eslint-disable-next-line no-new
  new Dropzone(dropzoneForm, {
    paramName: 'upload[file]',
    previewTemplate: document.getElementById('preview-template').innerHTML,
    previewsContainer: document.getElementById('attachments-previews-container'),
    sending: function (file, xhr) {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      if (token) xhr.setRequestHeader('X-CSRF-Token', token)
    },
    init: function () {
      let filesNum = 0
      const that = this

      this.on('addedfile', function (file) {
        filesNum++
        document.querySelectorAll('.done-link').forEach((el) => { el.style.display = 'none' })
      })
      this.on('complete', function (file) {
        filesNum--
        if (filesNum === 0) {
          document.querySelectorAll('.done-link').forEach((el) => { el.style.display = '' })
        }
      })

      this.on('error', function (file, error) {
        ErrorHandler.alertError(error.error || error, {
          delay: 5000,
          addOn: ' ' + (I18n.t('mailers.attachment_will_be_removed', {
            name: file.name
          }))
        })
        setTimeout(function () {
          file.previewElement.remove()
        }, 5000)
      })

      this.on('success', function (file, data) {
        const previewElement = file.previewElement
        if (data.id) {
          previewElement.id = 'att' + data.id
          const links = previewElement.querySelectorAll('.remover, a.filename')
          const url = links[0].getAttribute('href') + '/' + data.id
          links.forEach((link) => {
            link.setAttribute('href', url)
            link.style.display = 'inline'
          })
        } else {
          previewElement.querySelector('.remover').addEventListener('click', function () {
            that.removeFile(file)
          })
          if (data.error) {
            previewElement.classList.remove('dz-success')
            previewElement.classList.add('dz-error')
            const errorSpan = previewElement.querySelector('.dz-error-mark span')
            if (errorSpan) errorSpan.textContent = data.error
          }
        }
      })
    }
  })
}
